import React, { useMemo } from 'react';

import SimpleTableWithSorting, {
  generateColumn,
} from 'app/components/common/SimpleTableWithSorting';
import { TUser } from 'types';
import { formatUserTableShortDate } from 'utils/user-datetime-display';
import ChangePasswordCell from '../admin/users/ChangePasswordCell';

interface UsersTableProps {
  users: TUser[];
  showCreatedAt?: boolean;
  showUpdatedAt?: boolean;
}

export const UsersTable: React.FC<UsersTableProps> = ({
  users,
  showCreatedAt = false,
  showUpdatedAt = false,
}) => {
  const columns = useMemo(
    () => [
      generateColumn('id', {
        customCellFormatter: (props) => <ChangePasswordCell data={props} />,
      }),
      generateColumn('name'),
      generateColumn('email'),
      generateColumn('last_login_at', {
        customHeader: 'Ostatnie logowanie',
        customCellFormatter: (props) => (
          <div>{formatUserTableShortDate(props.getValue())}</div>
        ),
      }),
      generateColumn('last_activity_at', {
        customHeader: 'Ostatnia aktywność',
        customCellFormatter: (props) => (
          <div>{formatUserTableShortDate(props.getValue())}</div>
        ),
      }),
      ...(showCreatedAt
        ? [
            generateColumn('created_at', {
              customHeader: 'Utworzono',
              customCellFormatter: (props) => (
                <div>{formatUserTableShortDate(props.getValue())}</div>
              ),
            }),
          ]
        : []),
      ...(showUpdatedAt
        ? [
            generateColumn('updated_at', {
              customHeader: 'Zaktualizowano',
              customCellFormatter: (props) => (
                <div>{formatUserTableShortDate(props.getValue())}</div>
              ),
            }),
          ]
        : []),
    ],
    [showCreatedAt, showUpdatedAt]
  );

  return (
    <SimpleTableWithSorting
      columns={columns}
      data={users}
      hasFilters
      pageSize={50}
    />
  );
};

export default UsersTable;
